// CacheKey d14add941c5b3caad745e4fad93d6846
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { request } from '@services/EvolveApiService'

export default {
  tree: options =>
    request('get', '/vue/resource_materials/tree', options),

  reorder: options =>
    request('put', '/vue/resource_materials/reorder', options),

  create: options =>
    request('post', '/vue/resource_materials', options),

  get: options =>
    request('get', '/vue/resource_materials/:id', options),

  update: options =>
    request('patch', '/vue/resource_materials/:id', options),

  destroy: options =>
    request('delete', '/vue/resource_materials/:id', options),
}
